import React, { useState } from "react";
import "../../scss/index.scss";
import useWindowSize from "../../utils/useWindowSize";

const statusPill = (orderState) => {
  if (orderState === "Deposit Not Completed") {
    return (
      <span className="pill fail">
        <span className="pd" />
        Failed
      </span>
    );
  }
  if (orderState === "Refunded") {
    return (
      <span className="pill pend">
        <span className="pd" />
        {orderState}
      </span>
    );
  }
  if (orderState === "Completed") {
    return (
      <span className="pill done">
        <span className="pd" />
        {orderState}
      </span>
    );
  }
  return (
    <span className="pill pend">
      <span className="pd" />
      {orderState}
    </span>
  );
};

const cleanAmount = (amount) =>
  amount.replace(/^0+(?!\.)|(?:\.|(\..*?))0+$/gm, "$1");

const TableDataHomeTransactions = ({ item, currentDiv, tableOpen, openModal }) => {
  const sized = useWindowSize();
  const [openDiv, setOpenDiv] = useState(false);

  const openTable = () => {
    if (tableOpen === "") {
      setOpenDiv(true);
      currentDiv(item.id, openDiv);
    } else if (tableOpen === item.id) {
      setOpenDiv(!openDiv);
    } else if (tableOpen !== "" && tableOpen !== item.id) {
      setOpenDiv(true);
      currentDiv(item.id);
    }
  };

  const pair = (
    <div style={{ display: "flex", alignItems: "center", gap: 11, minWidth: 0 }}>
      <div className="coinPair">
        <span className="coinB">
          <img src={item.givenCoinImage.small} alt={item.givenCoin} />
        </span>
        <span className="coinB">
          <img src={item.getCoinImage.small} alt={item.getCoin} />
        </span>
      </div>
      <span className="cellStrong" style={{ whiteSpace: "nowrap" }}>
        {item.givenCoin} → {item.getCoin}
      </span>
    </div>
  );

  if (sized.width > 1024) {
    return (
      <div className="htRow">
        {pair}
        <div className="cellStrong" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {cleanAmount(item.depositAmount)}
          <img
            src={item.givenCoinImage.small}
            alt="giveCoin-img"
            width="18"
            height="18"
            style={{ borderRadius: "50%" }}
          />
        </div>
        <div>{statusPill(item.orderState)}</div>
        <div className="cellDate" style={{ color: "#7c847e" }}>
          {item.dateTimeCreated}
        </div>
      </div>
    );
  }

  const expanded = openDiv && tableOpen === item.id;

  return (
    <div className="mCard" style={{ margin: "0 16px 10px" }}>
      <div className="mTop" onClick={openTable}>
        {pair}
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {statusPill(item.orderState)}
          <span style={{ color: "#5d645f", fontSize: 12 }}>{expanded ? "▴" : "▾"}</span>
        </div>
      </div>

      {expanded && (
        <div className="mBody">
          <div className="mKV">
            <span className="k">ID</span>
            <span className="v">#{item.id}</span>
          </div>
          <div className="mKV">
            <span className="k">Amount</span>
            <span className="v" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              {cleanAmount(item.depositAmount)}
              <img
                src={item.givenCoinImage.small}
                alt="giveCoin-img"
                width="16"
                height="16"
                style={{ borderRadius: "50%" }}
              />
            </span>
          </div>
          <div className="mKV">
            <span className="k">Profit</span>
            <span className="v" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              {parseFloat(item.profit).toFixed(8)}
              {item.profitImageCurrency && (
                <img
                  src={item.profitImageCurrency}
                  alt="profit-currency"
                  width="16"
                  height="16"
                  style={{ borderRadius: "50%" }}
                />
              )}
            </span>
          </div>
          <div className="mKV">
            <span className="k">Client Email</span>
            <span className="v">
              {item.clientEmail}
              {item.clientEmail === "none" && typeof openModal === "function" && (
                <button
                  type="button"
                  className="btnGhost sm"
                  style={{ marginLeft: 8 }}
                  onClick={() => openModal(true)}
                >
                  Edit
                </button>
              )}
            </span>
          </div>
          <div className="mKV">
            <span className="k">Date created</span>
            <span className="v">{item.dateTimeCreated}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TableDataHomeTransactions;
